import {
  Button as ButtonMui,
  Radio as RadioMui,
  TextField,
  Tooltip as TooltipMui,
  LinearProgress,
} from '@mui/material';

import EditIconMui from '@mui/icons-material/Edit';
import ErrorIconMui from '@mui/icons-material/Error';
import HelpIconMui from '@mui/icons-material/Help';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { TYPOGRAPHY } from 'shared/design-system/settings/variables/Typography';
import { ANIMATIONS } from 'shared/design-system/settings/variables/Animation';
import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  min-height: calc(100vh - var(--app-header-height));
  padding-left: 0px !important;
  padding-right: 0px !important;
  display: flex !important;
  flex-direction: row;
  .mainSave {
    position: absolute !important;
    top: 12px;
    right: 0px;
    border-color: white;
    height: 32px;
    color: white !important;
    span {
      color: white !important;
    }
  }
  .hideWarning {
    position: absolute !important;
    right: 0px;
    border-color: #ffaf00;
    color: #ffaf00 !important;
    span {
      color: #ffaf00 !important;
    }
  }
  .pointer {
    cursor: pointer;
  }
  .error-alert {
    margin-top: 26px;
    margin-bottom: 26px;
    label {
      border-radius: 4px;
      padding: 10px;
      padding-left: 16px;
      padding-right: 16px;
      color: #566778;
      font-weight: 400;
      font-size: 16px;
      background-color: #ffe5e6;
    }
  }
  .warning-alert {
    margin-top: 26px;
    margin-bottom: 26px;
    label {
      border-radius: 4px;
      padding: 10px;
      padding-left: 16px;
      padding-right: 16px;
      color: #566778;
      font-weight: 400;
      font-size: 14px;
      background-color: #ffebc0;
    }
  }
  .complete-alert {
    color: ${COLORS.success};
    background-color: ${COLORS.successBackground};
    width: 100%;
    padding: ${SPACERS.medium} ${SPACERS.small};
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    svg {
      width: 40px;
      height: 40px;
    }
    .label {
      margin-bottom: 0;
    }
  }
`;

export const SideBar = styled.div`
  position: relative;
  min-width: 268px;
  width: 268px;
  background-color: #eaf0f6;
  color: ${COLORS.blackBase};
  .download-report-questions {
    text-align: center;
    margin-top: ${SPACERS.large};
  }
  .powered-by-logo {
    margin-top: ${SPACERS.small};
  }
  .stage-icon {
    padding-right: ${SPACERS.tiny};
  }
  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${SPACERS.tiny};
  }
  .sidebar-heading {
    padding: ${SPACERS.small};
  }
  .sidebar-subheading {
    margin: 0;
    padding: ${SPACERS.small};
    font-size: 16px;
    transition: all 0.2s ease-out;
  }
  .section-subtitle {
    font-size: ${TYPOGRAPHY.bodySmall};
    color: ${COLORS.greyDark};
    padding-left: ${SPACERS.medium};
  }
  .section {
    margin-top: ${SPACERS.small};
    padding: ${SPACERS.small};
    background-color: rgba(255, 255, 255, 0.4);
    display: flex;
    flex-direction: column;
    transition: background-color 0.15s ${ANIMATIONS.animationEasing};
    &:hover,
    &.active,
    &.selected {
      background-color: rgba(255, 255, 255, 0.8);
    }
    .svgCircle {
      background: #ffece3;
      width: 24px;
      height: 24px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    circle {
      fill: transparent;
      stroke: purple;

      stroke-width: 1px;
      stroke-dasharray: 50;
      stroke-dashoffset: 50;
      animation: clock-animation 10s linear infinite;
      transform: rotate(-90deg);
      transform-origin: center;
    }
    @keyframes clock-animation {
      0% {
        stroke-dashoffset: 50;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }

    .s-row-left {
      height: auto;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      margin-bottom: 12px;
    }
    .s-row {
      height: auto;
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
      .check {
        border: solid 1px ${COLORS.blackBase};
        width: 16px;
        height: 16px;
        border-radius: 8px;
      }
      .s-label {
        cursor: pointer;
        height: 32px;
        width: 100%;
        background-color: transparent;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        &.active {
          .s-name {
            font-weight: ${TYPOGRAPHY.fontWeightBold};
          }
          .check {
            cursor: pointer;
            border: solid 1px #535353;
          }
          .regular-2 {
          }
        }
      }
    }
  }
`;

export const Center = styled.div<{ padding?: string }>`
  position: relative;
  background-color: ${COLORS.whiteBase};

  flex: 1 1 auto;
  padding: ${props => props.padding || `0 ${SPACERS.extraLarge}`};
  min-height: calc(100vh - 180px);
  display: flex;
  flex-direction: column;
  gap: 40px;
  > * {
    margin: 0 auto;
  }
`;

export const BottomArea = styled.div<{ fixToBottom?: boolean }>`
  background-color: ${COLORS.whiteBase};
  position: ${props => (props.fixToBottom ? 'fixed' : 'relative')};
  width: ${props =>
    props.fixToBottom ? 'calc(100% - 348px)' : 'calc(100% - 348px)'};
  left: 308px;
  bottom: 0;
  border-top: solid 1px #9aa4ae;
  padding-right: 24px;
  padding-top: 24px;
  padding-bottom: 24px;
  min-height: 72px;
  z-index: 99;
  .buttons-wrapper {
    display: flex;
    justify-content: center;
    .buttons {
      width: 100%;
      max-width: 660px;
      display: flex;
      flex-direction: row;
      justify-content: center;
    }
  }
  .error-text {
    text-align: center;
    margin-bottom: ${SPACERS.small};
  }
`;

export const Content = styled.div<{ fullWidth?: boolean }>`
  width: 100%;
  max-width: ${props => (props.fullWidth ? '100%' : '660px')};
  height: 100%;
  .title-3 {
    color: #48596b;
    font-weight: 700;
    font-size: 24px;
    margin-block-start: 0px;
    margin-block-end: 16px;
  }
  .title-4 {
    color: #48596b;
    font-weight: 400;
    font-size: 32px;
    margin-block-start: 0px;
    margin-block-end: 16px;
  }
  .title-5 {
    color: #566778;
    font-weight: 700;
    font-size: 16px;
    margin-block-start: 0px;
    margin-block-end: 16px;
    text-transform: capitalize;
  }
  .title-6 {
    color: #b0bcc9;
    font-weight: 700;
    font-size: 16px;
    margin-block-start: 0px;
    margin-block-end: 16px;
  }
  .main-error-icon {
    transform: translateY(5px);
  }
  .MuiIconButton-label {
    width: 24px;
    height: 24px;
    svg {
      width: 24px;
      height: 24px;
    }
  }
`;

export const Input = styled(TextField)`
  width: 100%;
`;

export const Button = styled(ButtonMui)`
  flex: 1;
  height: 48px;
  :first-of-type {
    margin-right: 24px;
  }
  span {
    text-transform: none;
    font-weight: 700;
    font-size: 16px;
  }
  &.submit {
    background-color: #0072a2;
    span {
      color: #ffffff;
    }
    &:hover {
      background-color: #2c5768;
      span {
        color: #ffffff !important;
      }
    }
  }
`;

export const EditIcon = styled(EditIconMui)`
  color: #0072a2;
  cursor: pointer;
  width: 32px !important;
  height: 32px !important;
  background-color: #cbd6e2;
  border-radius: 50%;
  padding: 6px;
`;

export const ErrorIcon = styled(ErrorIconMui)`
  position: absolute;
  top: 0;
  left: 0;
  color: #fbaeb2;
  cursor: pointer;
  width: 32px !important;
  height: 32px !important;
  border-radius: 50%;
`;

export const WarningIcon = styled(HelpIconMui)`
  position: absolute;
  top: 0;
  left: 0;
  color: #ffcb57;
  cursor: pointer;
  width: 32px !important;
  height: 32px !important;
  border-radius: 50%;
`;

export const ErrorBox = styled.div<{ isWarning?: boolean }>`
  display: inline-block;
  width: 32px !important;
  height: 32px !important;
  background-color: ${props => (props.isWarning ? '#ffcb57' : '#fbaeb2')};
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  .circle {
    position: absolute;
    top: 4px;
    left: 4px;
    background-color: ${props => (props.isWarning ? '#ab7c36' : '#d95d5f')};
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }
  &:before {
    transition: all 0.2s ease-out;
    content: '';
    position: absolute;
    top: 4px;
    left: 4px;
    background-color: ${props => (props.isWarning ? '#ab7c36' : '#d95d5f')};
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }
  &:hover {
    &:before {
      background-color: ${props => (props.isWarning ? '#f9e689' : '#fcd7d9')};
      border: solid 1px ${props => (props.isWarning ? '#ab7c36' : '#d95d5f')};
      top: -4px;
      left: -4px;
      width: 40px;
      height: 40px;
    }
  }
`;

const baseSmallIcon = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  svg {
    color: ${COLORS.blackBase};
  }
`;

export const CheckGood = styled(baseSmallIcon)`
  svg {
    color: ${COLORS.success};
  }
`;

export const CheckError = styled(baseSmallIcon)`
  svg {
    color: ${COLORS.critical};
  }
`;

export const CheckWarning = styled(baseSmallIcon)`
  svg {
    color: ${COLORS.warning};
  }
`;

export const Tooltip = styled(TooltipMui)``;

export const SectionOptions = styled.div<{ h: number }>`
  height: ${props => props.h}px;
  padding-left: ${SPACERS.medium};
  transition: height 0.2s ease-out;
  display: flex;
  flex-direction: column;
  gap: ${SPACERS.tiny};
  overflow: hidden;
  .s-row:first-child {
    padding-top: ${SPACERS.small};
  }
`;

export const Radio = styled(RadioMui)`
  &.Mui-checked {
    color: #f89a0c !important;
  }
  svg {
    font-size: 35px;
  }
`;

export const Section = styled.div`
  width: 100%;
  min-height: calc(100vh - 180px);
  display: flex;
  flex-direction: column;
  gap: ${SPACERS.small};
  padding: ${SPACERS.large} 0 120px;
`;

export const Progress = styled(LinearProgress)<{ display?: boolean }>`
  transition: width 0.3s ease-out;
  position: absolute !important;
  background-color: #0072a2 !important;
  width: ${props => (props.display ? '100%' : '0%')};
  top: 0px;
  left: 0px;
  .MuiLinearProgress-barColorPrimary {
    background-color: #bccdd1 !important;
  }
`;

export const Link = styled.span`
  cursor: pointer;
  text-decoration: underline;
  color: #0072a2;
  font-weight: 700;
  font-size: 17px;
`;

export const CalendarContainer = styled.div`
  background-color: ${COLORS.greyLightest};
  padding: ${SPACERS.small};
  overflow: hidden;
  border-radius: 4px;
  .MuiPickersCalendarHeader-iconButton {
    background-color: ${COLORS.greyLight};
    &:hover {
      background-color: ${COLORS.greyBase};
    }
  }
  .MuiPickersDay-root.Mui-selected {
    background-color: ${COLORS.ctaPrimary} !important;
    color: ${COLORS.whiteBase} !important;
    &:hover,
    &:focus {
      background-color: ${COLORS.ctaPrimaryHover} !important;
    }
  }
`;

export const Underline = styled.span`
  @keyframes expand {
    0% {
      background-size: 0 3px;
    }
    100% {
      background-size: 0 3px, 100% 3px;
    }
  }
  display: inline-block;
  position: relative;
  cursor: pointer;
  overflow: visible;
  background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)),
    linear-gradient(to right, ${COLORS.ctaBrand}, ${COLORS.ctaBrand});
  background-position: 100% 100%, 0 100%;
  background-repeat: no-repeat;
  background-size: 100% 3px, 0 3px;
  background-position: center 100%, center 100%;
  background-repeat: no-repeat;
  animation-name: expand;
  animation-duration: 0.15s;
  animation-delay: 1s;
  animation-timing-function: ${ANIMATIONS.easing};
  animation-fill-mode: forwards;
`;
